module.exports = __webpack_public_path__ + "img/SkillsDivider.89bc9ebe.svg";